<template>
    <h2 class="flex items-center gap-2 text-content-lg font-semibold">
        {{ heading }}

        <slot />
    </h2>
</template>

<script setup lang="ts">
defineProps<{
    heading: string;
}>();
</script>
